import classNames from "classnames";
import { useBoolean } from "hooks";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "ui";

import { useCollectMoney, usePayDriver } from "../../../apis";
import { DeliveryStatus } from "../../../constants";
import { ActionCellProps } from "../DeliveriesTable.types";

import styles from "../DeliveriesTable.module.scss";

export const ActionCell = ({ item, refetchDeliveries }: ActionCellProps) => {
  const { t } = useTranslation();

  const {
    value: isConfirmCollectModalOpen,
    setTrue: openConfirmCollectModal,
    setFalse: closeConfirmCollectModal
  } = useBoolean(false);

  const {
    value: isPayDriverModalOpen,
    setTrue: openPayDriverModal,
    setFalse: closePayDriverModal
  } = useBoolean(false);

  const collectMoney = useCollectMoney({
    onSuccess: () => {
      closeConfirmCollectModal();
      toast.success(t("Money collection confirmed successfully"));
      refetchDeliveries();
    }
  });

  const payDriver = usePayDriver({
    onSuccess: () => {
      closeConfirmCollectModal();
      toast.success(t("Driver paid successfully"));
      refetchDeliveries();
    }
  });

  if (item.amountToCollect !== 0) {
    return (
      <>
        <Button
          disabled={item.status !== DeliveryStatus.Delivered}
          onClick={openConfirmCollectModal}
        >
          {t("Confirm Collection")}
        </Button>

        <Modal
          isOpen={isConfirmCollectModalOpen}
          title="Confirm Collection"
          isLoading={collectMoney.isLoading}
          okText="Confirm"
          onOk={() => collectMoney.mutate(item.id)}
          contentClassName={styles.confirmModal}
          onClose={closeConfirmCollectModal}
        >
          <p className={styles.confirmModal_text}>
            {t("Are you sure that money are collected and driver is paid?")}
          </p>
        </Modal>
      </>
    );
  }

  if (item.isCollected) {
    return (
      <div className={classNames(styles.deliveries_successActionLabel)}>
        {t("COLLECTED")}
      </div>
    );
  }

  if (item.amountToPay && !item.isPaid) {
    return (
      <>
        <Button
          disabled={item.status !== DeliveryStatus.Delivered}
          onClick={openPayDriverModal}
        >
          {t("Pay driver")}
        </Button>

        <Modal
          isOpen={isPayDriverModalOpen}
          title={t("Pay Driver")}
          isLoading={payDriver.isLoading}
          okText={t("Confirm")}
          onOk={() => payDriver.mutate(item.id)}
          contentClassName={styles.confirmModal}
          onClose={closePayDriverModal}
        >
          <p className={styles.confirmModal_text}>
            {t("Are you sure that driver is paid?")}
          </p>
        </Modal>
      </>
    );
  }

  if (item.isPaid) {
    return (
      <div className={classNames(styles.deliveries_successActionLabel)}>
        {t("Driver paid")}
      </div>
    );
  }

  return null;
};
